import { FC, SVGProps } from 'react';

export const TrashIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.1667 18.3333H5.83333C4.91286 18.3333 4.16667 17.5871 4.16667 16.6667V5.83334H2.5V4.16667H5.83333V3.33334C5.83333 2.41286 6.57953 1.66667 7.5 1.66667H12.5C13.4205 1.66667 14.1667 2.41286 14.1667 3.33334V4.16667H17.5V5.83334H15.8333V16.6667C15.8333 17.5871 15.0871 18.3333 14.1667 18.3333ZM5.83333 5.83334V16.6667H14.1667V5.83334H5.83333ZM7.5 3.33334V4.16667H12.5V3.33334H7.5ZM12.5 15H10.8333V7.50001H12.5V15ZM9.16667 15H7.5V7.50001H9.16667V15Z" fill="currentColor" />
  </svg>
);
